import { useContext } from 'react';
import { WorkflowPanelContext, type WorkflowPanelContextValue } from './WorkflowPanelContext';

export function useWorkflowPanel(): WorkflowPanelContextValue {
  const ctx = useContext(WorkflowPanelContext);
  if (!ctx) {
    throw new Error('useWorkflowPanel must be used inside WorkflowPanelProvider');
  }
  return ctx;
}
